<template>
  <div class="sharedata-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <!--<div class="card-title">
            最新资讯
          </div>-->
          <div class="card-content">
            <div class="sort">
              <div class="wrap">
                <div class="sort-mode">
                  <el-button type="text" :class="sort===0?'sort-btn sort-this':'sort-btn'" @click="getSortData(0)">最新资讯</el-button>
                  <el-button type="text" :class="sort===1?'sort-btn sort-this':'sort-btn'" @click="getSortData(1)">浏览最多</el-button>
                </div>
                <div class="search-mode">
                  <input type="text" class="search-input" placeholder="搜索资讯" v-model="search" />
                  <el-button class="search-btn" icon="el-icon-search" @click="searchNews"/>
                </div>
              </div>
            </div>
            <ul class="sharedata-list" v-loading="newsLoading">
              <li v-for="d in newsData">
                <router-link :to="{path:'/news/news_detail/'+d.newsid}">
                  <div class="sharedata-img" :style="'background-image: url('+d.img_url+')'"></div>
                  <div class="sharedata-title">{{d.title}}</div>
                  <div class="sharedata-author" v-if="d.username===null||d.username===''"><i class="el-icon-share"/> Elichain</div>
                  <div class="sharedata-author" v-if="d.username!==null&&d.username!==''"><i class="el-icon-share"/> {{d.username}}</div>
                  <div class="sharedata-info">
                    <span><i class="el-icon-time"></i>{{d.time}}</span>
                    <span><i class="el-icon-view"></i> {{d.views}}</span>
                  </div>
                </router-link>
              </li>
            </ul>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getNewsPC } from '@/api/home'
export default {
  name: 'news_list',
  data(){
    return{
      newsLoading: false,
      newsData : [],
      pageSize : 10,
      currentPage: 1,
      total: 0,
      sort: 0,
      search: ''
    }
  },
  computed:{
    user: getUser
  },
  created() {
    this.getNewsData()
  },
  methods:{
    getNewsData() {//获取资讯
      this.newsLoading = true
      const _this = this
      const data = {
        page: _this.currentPage,
        limit: _this.pageSize,
        content: _this.search,
        status: _this.sort
      }
      getNewsPC(data).then(response=>{
        _this.newsData = response.data.list
        _this.total = response.data.total
        _this.newsLoading = false
      })
    },
    getSortData(sort){
      this.sort = sort
      this.getNewsData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getNewsData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getNewsData()
    },
    searchNews(){
      this.currentPage = 1
      this.getNewsData()
    },
  }
}
</script>

<style lang="scss" scoped>
  .sharedata-container {
    .sharedata-list{
      padding: 0;
      margin: 20px 0;
      width: 100%;
      position: relative;
      list-style: none;
      min-height: 100px;
      li{
        width: 460px;
        height: 100px;
        padding: 10px 10px 10px 100px;
        position: relative;
        cursor: pointer;
        float: left;
        margin: 10px;
        border-radius: 2px;
        .sharedata-img{
          position: absolute;
          left: 10px;
          top: 10px;
          width: 80px;
          height: 80px;
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 2px;
        }
        .sharedata-title{
          padding-top: 2px;
          line-height: 20px;
          font-size: 14px;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .sharedata-author{
          color:#999;
          font-size: 12px;
          line-height: 20px;
        }
        .sharedata-info{
          width: 100%;
          line-height: 20px;
          color:#999;
          font-size: 12px;
          span{
            margin-right: 20px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
        &:hover{
          background: #f5f7fa;
          .sharedata-title{
            color:#409EFF;
          }
        }
      }
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
    }
    .sort{
      position: relative;
      padding: 0;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f5f7fa;
      .wrap{
        box-sizing: content-box;
        .sort-mode{
          overflow: visible;
          float: left;
          .sort-btn{
            color: #606266;
            font-size: 13px;
            font-weight: 400;
            margin-right: 20px;
          }
          .sort-this{
            color: #409EFF;
            font-weight: 500;
          }
        }
        .search-mode{
          float: right;
          width: 300px;
          .search-input{
            background-color: #F2F6FC;
            border:0;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn{
            position: absolute;
            right: 0;
            height: 32px;
            width: 40px;
            line-height: 32px;
            top: 10px;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
    }
  }
</style>
